import * as React from "react";
import styled from "styled-components";
import Slider from "rc-slider";
import Cigarrette from '../resources/cigarrete.svg';

const SliderComp = (props) => {
  const [touched, setTouched] = React.useState(false);

  const isUnanswered = props.answer === undefined || props.answer === 999;
  const currentValue = isUnanswered ? 0 : props.answer;

  const handleLabel = (node, handleProps) => {
    const left = parseFloat(node.props.style.left) - 2.2;

    return (
      <TooltipWrap>
        <span style={{ position: "absolute", left: `${left}%` }}>
          {isUnanswered && !touched ? '--' : `${handleProps.value}${(handleProps.value === 30 && props.showPlus) || (props.maxValue === 6 && handleProps.value === 6 && props.showPlus) ? '+' : ""}`}
        </span>
        {node}
      </TooltipWrap>
    );
  };

  const onBeforeChange = () => {
    if (!touched) {
      setTouched(true);
      props.handleAnswerChange(0, props.index); // Set to 0 when user starts sliding
    }
  };

  const onChange = (value) => {
    props.handleAnswerChange(value, props.index);
  };

  return (
    <SliderWrap>
      <Slider
        value={currentValue}
        min={props.min || 0}
        max={props.maxValue || 30}
        onBeforeChange={onBeforeChange}
        onChange={onChange}
        styles={{
          handle: {
            borderColor: "#025dc7",
            marginTop: -4,
            backgroundImage: `url(${props.icon ? props.icon : Cigarrette})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            opacity: isUnanswered && !touched ? "30%" : "100%" // Greyed out until interacted
          }
        }}
        handleRender={handleLabel}
        trackStyle={{ backgroundColor: "#025dc7", borderRadius: 50 }}
        railStyle={{ backgroundColor: "#EBEBED", borderRadius: 50 }}
      />
    </SliderWrap>
  );
};

const SliderWrap = styled.div`
.rc-slider-rail, .rc-slider-track {
  height: 30px;
}
.rc-slider-handle {
  height: 40px;
  width: 40px;
  background-size: 30px 30px;
  &:focus {
    outline: black;
  }
}
@media only screen and (max-width: 700px) {
  .rc-slider-rail, .rc-slider-track {
    height: 20px;
  }
  .rc-slider-handle {
    height: 30px;
    width: 30px;
    background-size: 25px 25px;
  }
  .rc-slider-handle-dragging {
    box-shadow: 0 0 0 3px #96dbfa !important;
  }
}
margin: 25px 10px 40px;
@media only screen and (max-width: 700px) {
  margin: 10px 7px 30px;
}
`;

const TooltipWrap = styled.section`
span {
  font-size: 18px;
  bottom: 12px;
  @media only screen and (max-width: 700px) {
    font-size: 8px;
    bottom: 10px;
  }
}
`;

export default SliderComp;
